import React from 'react';
import Bodentemperatur from '../components/Bodentemperatur';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodentemperaturGippel() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodentemperatur-gippel-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodentemperatur-gippel-heading">BODENTEMPERATUR</h1>
        </div>

        <Bodentemperatur ort="gippel" />
      </div>
    </div>
  );
}

export default BodentemperaturGippel;
